import { ChangeDetectionStrategy, Component } from '@angular/core';
import { WhitelabelConfigStore } from '../core/config/whitelabel-config.store';

@Component({
  selector: 'app-parcel',
  templateUrl: './parcel.component.html',
  styleUrls: ['./parcel.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ParcelComponent {
  private readonly defaultFeatures = [
    'On-time, reliable delivery across our network.',
    'Available 24/7, just a call away.',
    'Well-trained staff dedicated to great service.',
    'Refrigerated buses for perishable cargo.',
    'Live location tracking to avoid delivery errors.',
    'Service points situated across our network.'
  ];

  constructor(public readonly configStore: WhitelabelConfigStore) {}

  get parcel(): Record<string, any> {
    return this.configStore.getConfig('content.parcel', {});
  }

  get operatorName(): string {
    return this.configStore.getConfig('site.name', 'Bus operator');
  }

  get parcelEmail(): string {
    return this.parcel['email'] || this.configStore.getConfig('site.supportEmail', '');
  }

  get parcelEmailHref(): string {
    return `mailto:${this.parcelEmail}`;
  }

  get features(): string[] {
    return this.parcel['features'] || this.defaultFeatures;
  }
}
